module.exports = ".fixedbutton {\n    position: fixed;\n    bottom: 30px;\n    right: 20px; \n}"